import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/ic_pdf@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-12d30a9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gy" }
const _hoisted_2 = { class: "gy_info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gy_info_title" }, "物料信息", -1))
const _hoisted_4 = { class: "gy_info_box" }
const _hoisted_5 = { class: "gy_info_box_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "物料编码：", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "gy_info_box_item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "物料名称：", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "gy_info_box_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "单位：", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "gy_info_box_item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "版本号：", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gy_gx" }, "工序信息", -1))
const _hoisted_18 = { class: "gy_gxinfo" }
const _hoisted_19 = { class: "gy_gxinfo_item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "工序名称：", -1))
const _hoisted_21 = { class: "gy_gxinfo_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "注意事项：", -1))
const _hoisted_23 = { class: "gy_gxinfo_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "工艺文件：", -1))
const _hoisted_25 = {
  key: 0,
  class: "list"
}
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  class: "file"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gy_z" }, null, -1))

import { ref, onMounted } from 'vue'
    import { QRCodeType } from '@/enum'
    import { Toast } from 'vant'
    import { judgmentType } from '@/utils/utils'
    import { useRouter, useRoute } from "vue-router"
    import { getBarcodeContent, getListByWorkOrderId } from '@/apis/WorkOrderAPI'
    import { queryListByCode } from '@/apis'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()
    const route = useRoute()

    let desc = ref<object>({})

    let openCode = ref<boolean>(false)

    const show = ref(false);
    const index = ref(1);

    // 预览的图片数据
    let images = ref<string[]>([])

    const onChange = (newIndex: any) => {
        index.value = newIndex + 1;
    };

    // 跳转预览pdf
    const jumpPreview = (url: string) => {
        document.location.href = `${process.env.VUE_APP_PDF}?url=${url}`
    }

    const open = () => {
        openCode.value = true
    }

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 获取详情
    const info = (id: string): void => {
        queryListByCode({
            dicCode: 'FOLDER',
            label: 'ROUTE_CARD'
        }).then(data => {
            if (data.code === 200) {
                getListByWorkOrderId({ workOrderId: id })
                    .then(res => {
                        if (res.code === 200) {
                            res.data.url = res.data.resourcePath + data.data[0].code + '/' + res.data.fileurl
                            let index = res.data.fileurl.lastIndexOf('.')
                            let code = res.data.fileurl.substring(index + 1, res.data.fileurl.length)
                            res.data.type = judgmentType(code.toLowerCase())
                            if (res.data.type) {
                                images.value = []
                                images.value.push(res.data.url)
                            }
                            desc.value = res.data
                        }
                    })
            }
        })
    }

    // 获取扫码值
    const onDecode = (data: string[]): void => {
        openCode.value = false
        getBarcodeContent({ barcode: data[0] })
            .then(res => {
                if (res.code === 200) {
                    if (res.data.barcodeType !== QRCodeType.GZ && res.data.barcodeType !== QRCodeType.GD) {
                        return Toast.fail({ message: '请扫描正确的工装码/工单码' })
                    }
                    info(res.data.id)
                }
            })
    }

    onMounted(() => {
        info(route.query.id as string)
    })

return (_ctx: any,_cache: any) => {
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!
  const _component_van_image_preview = _resolveComponent("van-image-preview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_unref(desc).mmodel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(desc).mmodel.code ? _unref(desc).mmodel.code : '-'), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_unref(desc).mmodel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(desc).mmodel.name ? _unref(desc).mmodel.name : '-'), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          (_unref(desc).umodel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(desc).umodel.name ? _unref(desc).umodel.name : '-'), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          (_unref(desc).mmodel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(desc).mmodel.attr ? _unref(desc).mmodel.attr : '-'), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("span", null, _toDisplayString(_unref(desc).procedureName ? _unref(desc).procedureName : '-') + "｜" + _toDisplayString(_unref(desc).procedureCode ? _unref(desc).procedureCode : '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("span", null, _toDisplayString(_unref(desc).tips ? _unref(desc).tips : '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        (_unref(desc).type)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", {
                class: "list_item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true))
              }, [
                _createElementVNode("img", {
                  src: _unref(desc).url,
                  alt: ""
                }, null, 8, _hoisted_26)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", {
                class: "file_item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (jumpPreview(_unref(desc).url)))
              }, [
                _hoisted_28,
                _createElementVNode("u", null, _toDisplayString(_unref(desc).remark), 1)
              ])
            ]))
      ])
    ]),
    _hoisted_29,
    _createElementVNode("div", { class: "gy_footer" }, [
      _createElementVNode("button", {
        class: "gy_footer_sCode",
        onClick: open
      }, "扫码")
    ]),
    _createVNode(_component_v_ScanCode, {
      openCode: _unref(openCode),
      infos: ['请扫码工装码/工单码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"]),
    _createVNode(_component_van_image_preview, {
      show: show.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
      images: _unref(images),
      onChange: onChange
    }, null, 8, ["show", "images"])
  ]))
}
}

})